import Head  from 'next/head'

import Header from '../components/Header';
import Footer from '../components/Footer';

interface IMainLayoutProps {
  children: React.ReactNode
  title?: string
}

export default function MainLayout(props: IMainLayoutProps) {
  return <>
    <Head>
      <title>{props.title || 'ГУП Таттехмедфарм - бронирование лекарств, БАДов и изделий мед. назначения'}</title>
    </Head>
    
    <Header />
    <main>
      {props.children}
    </main>
    <Footer />
  </>
}